<div class="detail-page">
  <a class="detail-back" [routerLink]="['/transaction/list']">
    <app-detail-icon name="arrow-left" [size]="15"></app-detail-icon>
    Back to Transactions
  </a>

  <ng-container *ngIf="transactionData as transaction">
    <!-- Header: identity -->
    <header class="detail-header">
      <div>
        <h1 class="detail-header__title">
          Transaction #{{ transaction.trans_session_id }}
        </h1>
        <div class="detail-header__meta">
          <span class="detail-mono">{{ transaction.trans_session_id }}</span>
          <span>{{ transaction.created_at | date: 'MMM d y, hh:mm a' }}</span>
          <span *ngIf="transaction.created_by">
            by {{ transaction.created_by }}
          </span>
        </div>
      </div>
    </header>

    <div class="detail-stack">
      <!-- Money summary -->
      <section class="detail-card">
        <div class="detail-card__head">
          <app-detail-icon
            class="detail-card__icon"
            name="banknote"
            [size]="18"></app-detail-icon>
          <h2 class="detail-card__title">Transaction Summary</h2>
        </div>

        <div class="detail-figures">
          <div class="detail-figure">
            <div class="detail-figure__label">
              <span>Source Amount</span>
              <img
                [src]="
                  'assets/images/country-square/' +
                  transaction.source_country +
                  '.png'
                "
                alt=""
                class="detail-flag"
                onerror="this.style.display='none'" />
            </div>
            <div class="detail-figure__value">
              {{ transaction.source_amount }}
              <small>{{ transaction.source_currency }}</small>
            </div>
          </div>

          <div class="detail-figure detail-figure--accent">
            <div class="detail-figure__label">
              <span>Destination Amount</span>
              <img
                [src]="
                  'assets/images/country-square/' +
                  transaction.destination_country +
                  '.png'
                "
                alt=""
                class="detail-flag"
                onerror="this.style.display='none'" />
            </div>
            <div class="detail-figure__value">
              {{ transaction.destination_amount }}
              <small>{{ transaction.destination_currency }}</small>
            </div>
          </div>

          <div class="detail-figure">
            <div class="detail-figure__label"><span>Amount Paid</span></div>
            <div class="detail-figure__value">
              {{ transaction.amount_paid || 0 }}
              <small>{{ transaction.source_currency }}</small>
            </div>
          </div>

          <div class="detail-figure">
            <div class="detail-figure__label"><span>Remaining</span></div>
            <div class="detail-figure__value">
              {{ transaction.remaining_amount }}
              <small>{{ transaction.source_currency }}</small>
            </div>
          </div>
        </div>
      </section>

      <div class="detail-grid">
        <!-- Left column -->
        <div class="detail-stack">
          <section class="detail-card">
            <div class="detail-card__head">
              <app-detail-icon
                class="detail-card__icon"
                name="receipt"
                [size]="18"></app-detail-icon>
              <h2 class="detail-card__title">Transaction Overview</h2>
            </div>

            <div class="detail-kv">
              <span class="detail-kv__label">Status</span>
              <span class="detail-kv__value">
                <span
                  class="detail-pill"
                  [ngClass]="transaction.transaction_status | statusPill">
                  {{ transaction.transaction_status }}
                </span>
              </span>
            </div>
            <div class="detail-kv" *ngIf="transaction.pay_in_status">
              <span class="detail-kv__label">Pay-In Status</span>
              <span class="detail-kv__value">
                <span
                  class="detail-pill"
                  [ngClass]="transaction.pay_in_status | statusPill">
                  {{ transaction.pay_in_status }}
                </span>
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Amount Type</span>
              <span class="detail-kv__value">
                {{ transaction.amount_type | titlecase }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Transaction Reference</span>
              <span class="detail-kv__value detail-mono">
                {{ transaction.trans_session_id }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Partner ID</span>
              <span class="detail-kv__value detail-mono">
                {{ transaction.partner_id }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Created Date</span>
              <span class="detail-kv__value">
                {{ transaction.created_at | date: 'MMM d y, hh:mm a' }}
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Created By</span>
              <span class="detail-kv__value">
                {{ transaction.created_by || '—' }}
              </span>
            </div>

            <div class="detail-section">
              <div class="detail-section__title">Transfer</div>
              <div class="detail-kv" *ngIf="transaction.purpose">
                <span class="detail-kv__label">Purpose</span>
                <span class="detail-kv__value">{{ transaction.purpose }}</span>
              </div>
              <div class="detail-kv" *ngIf="transaction.source_of_income">
                <span class="detail-kv__label">Source of Income</span>
                <span class="detail-kv__value">
                  {{ transaction.source_of_income }}
                </span>
              </div>
              <div class="detail-kv" *ngIf="transaction.payment_type_pi">
                <span class="detail-kv__label">Payment Type</span>
                <span class="detail-kv__value">
                  {{ transaction.payment_type_pi }}
                </span>
              </div>
              <div class="detail-kv" *ngIf="transaction.transfer_type_po">
                <span class="detail-kv__label">Transfer Type</span>
                <span class="detail-kv__value">
                  {{ transaction.transfer_type_po }}
                </span>
              </div>
            </div>

            <div class="detail-section">
              <div class="detail-section__title">Transaction IDs</div>
              <div class="detail-kv">
                <span class="detail-kv__label">Pay-In</span>
                <span class="detail-kv__value detail-mono">
                  {{ transaction.pay_in_trans_id || 'N/A' }}
                </span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv__label">Pay-Out</span>
                <span class="detail-kv__value detail-mono">
                  {{ transaction.pay_out_trans_id || 'N/A' }}
                </span>
              </div>
            </div>
          </section>

          <section class="detail-card">
            <div class="detail-card__head">
              <app-detail-icon
                class="detail-card__icon"
                name="shield-check"
                [size]="18"></app-detail-icon>
              <h2 class="detail-card__title">Compliance</h2>
            </div>

            <div class="detail-kv">
              <span class="detail-kv__label">Compliance Needed</span>
              <span class="detail-kv__value">
                <span
                  class="detail-pill"
                  [ngClass]="
                    transaction.compliance_needed
                      ? 'detail-pill--warn'
                      : 'detail-pill--plain'
                  ">
                  {{ transaction.compliance_needed ? 'Yes' : 'No' }}
                </span>
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Compliance Checked</span>
              <span class="detail-kv__value">
                <span
                  class="detail-pill"
                  [ngClass]="
                    transaction.compliance_checked
                      ? 'detail-pill--success'
                      : 'detail-pill--plain'
                  ">
                  {{ transaction.compliance_checked ? 'Yes' : 'No' }}
                </span>
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Ext. Compliance Needed</span>
              <span class="detail-kv__value">
                <span
                  class="detail-pill"
                  [ngClass]="
                    transaction.ext_compliance_needed
                      ? 'detail-pill--warn'
                      : 'detail-pill--plain'
                  ">
                  {{ transaction.ext_compliance_needed ? 'Yes' : 'No' }}
                </span>
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Ext. Compliance Checked</span>
              <span class="detail-kv__value">
                <span
                  class="detail-pill"
                  [ngClass]="
                    transaction.ext_compliance_checked
                      ? 'detail-pill--success'
                      : 'detail-pill--plain'
                  ">
                  {{ transaction.ext_compliance_checked ? 'Yes' : 'No' }}
                </span>
              </span>
            </div>
          </section>

          <section
            class="detail-card detail-card--danger"
            *ngIf="
              transaction.transaction_status === 'Reject' && transaction.reason
            ">
            <div class="detail-card__head">
              <app-detail-icon
                class="detail-card__icon text-danger"
                name="alert-triangle"
                [size]="18"></app-detail-icon>
              <h2 class="detail-card__title">Rejection Reason</h2>
            </div>
            <p class="detail-muted mb-0">{{ transaction.reason }}</p>
          </section>
        </div>

        <!-- Right column -->
        <div class="detail-stack">
          <section class="detail-card">
            <div class="detail-card__head">
              <app-detail-icon
                class="detail-card__icon"
                name="users"
                [size]="18"></app-detail-icon>
              <h2 class="detail-card__title">Parties</h2>
            </div>

            <div class="detail-section__title">Sender</div>
            <div class="detail-kv">
              <span class="detail-kv__label">Sender ID</span>
              <span class="detail-kv__value">
                <a
                  [routerLink]="[
                    '/sender/details',
                    isSuperAdmin
                      ? transaction.sender_id + '-' + transaction.partner_id
                      : transaction.sender_id,
                  ]">
                  #{{ transaction.sender_id }}
                </a>
              </span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Name</span>
              <span class="detail-kv__value">{{ senderName }}</span>
            </div>
            <div class="detail-kv">
              <span class="detail-kv__label">Source Country</span>
              <span class="detail-kv__value">
                <img
                  [src]="
                    'assets/images/country-square/' +
                    transaction.source_country +
                    '.png'
                  "
                  alt=""
                  class="detail-flag me-1"
                  onerror="this.style.display='none'" />
                {{ transaction.source_country }}
              </span>
            </div>

            <div class="detail-section">
              <div class="detail-section__title">Recipient</div>
              <div class="detail-kv">
                <span class="detail-kv__label">Recipient ID</span>
                <span class="detail-kv__value">
                  <a
                    [routerLink]="[
                      '/recipient/details',
                      isSuperAdmin
                        ? transaction.beneficiary_id +
                          '-' +
                          transaction.partner_id
                        : transaction.beneficiary_id,
                    ]">
                    #{{ transaction.beneficiary_id }}
                  </a>
                </span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv__label">Name</span>
                <span class="detail-kv__value">{{ recipientName }}</span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv__label">Mobile Number</span>
                <span class="detail-kv__value">
                  <a [href]="'tel:' + transaction.beneficiary_mobile_number">
                    {{ transaction.beneficiary_mobile_number }}
                  </a>
                </span>
              </div>
              <div class="detail-kv">
                <span class="detail-kv__label">Destination Country</span>
                <span class="detail-kv__value">
                  <img
                    [src]="
                      'assets/images/country-square/' +
                      transaction.destination_country +
                      '.png'
                    "
                    alt=""
                    class="detail-flag me-1"
                    onerror="this.style.display='none'" />
                  {{ transaction.destination_country }}
                </span>
              </div>
              <div
                class="detail-kv"
                *ngIf="transaction.sender_beneficiary_relation">
                <span class="detail-kv__label">Relationship</span>
                <span class="detail-kv__value">
                  {{ transaction.sender_beneficiary_relation }}
                </span>
              </div>
            </div>
          </section>

          <!-- Status update -->
          <section
            class="detail-card"
            *appHasAccess="'update-transaction-status'">
            <div class="detail-card__head">
              <app-detail-icon
                class="detail-card__icon"
                name="pencil"
                [size]="18"></app-detail-icon>
              <h2 class="detail-card__title">Update Pay-in Status</h2>
            </div>

            <form
              class="mat-form"
              [formGroup]="updateTxnStatusForm"
              (ngSubmit)="onTxnStatusUpdate()">
              <div class="form-group">
                <app-input-select
                  (selectionChange)="onTxnStatusChange($event)"
                  [inputData]="attrConstant.transaction_status"
                  [selectOptions]="
                    userInfo?.mode === 'ONLINE'
                      ? onlineTransactionStatus
                      : offlineTransactionStatus
                  "
                  [bindLabel]="'name'"
                  [bindValue]="'value'"
                  [formControlName]="attrConstant.transaction_status.key">
                </app-input-select>
              </div>

              <div class="form-group mb-2">
                @if (selectedStatus === 'Partial Payment') {
                  <app-input-template
                    [inputData]="attrConstant.amount_paid"
                    [formControlName]="attrConstant.amount_paid.key">
                  </app-input-template>
                } @else if (selectedStatus === 'Reject') {
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ attrConstant.reason.label }}</mat-label>
                    <textarea
                      matInput
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="2"
                      cdkAutosizeMaxRows="5"
                      [formControlName]="attrConstant.reason.key">
                    </textarea>
                  </mat-form-field>
                }
              </div>

              <button
                type="submit"
                class="detail-btn detail-btn--solid detail-btn--block"
                [disabled]="transaction.transaction_status === 'Paid'">
                <app-detail-icon
                  name="check-circle"
                  [size]="15"></app-detail-icon>
                Submit
              </button>
            </form>
          </section>

          <!-- Pay-out status update (one partner only) -->
          <section class="detail-card" *ngIf="canUpdatePayoutStatus">
            <div class="detail-card__head">
              <app-detail-icon
                class="detail-card__icon"
                name="pencil"
                [size]="18"></app-detail-icon>
              <h2 class="detail-card__title">Update Pay-out Status</h2>
            </div>

            <form
              class="mat-form"
              [formGroup]="updatePayoutStatusForm"
              (ngSubmit)="onPayoutStatusUpdate()">
              <div class="form-group mb-2">
                <app-input-select
                  [inputData]="attrConstant.payout_status"
                  [selectOptions]="payoutStatus"
                  [bindLabel]="'name'"
                  [bindValue]="'value'"
                  [formControlName]="attrConstant.payout_status.key">
                </app-input-select>
              </div>

              <button
                type="submit"
                class="detail-btn detail-btn--solid detail-btn--block">
                <app-detail-icon
                  name="check-circle"
                  [size]="15"></app-detail-icon>
                Submit
              </button>
            </form>
          </section>

          <!-- Payment history -->
          <section
            class="detail-card"
            *ngIf="
              transaction.transaction_status === 'Partial Payment' ||
              transaction.transaction_status === 'Paid'
            ">
            <div class="detail-card__head">
              <app-detail-icon
                class="detail-card__icon"
                name="clock"
                [size]="18"></app-detail-icon>
              <h2 class="detail-card__title">Payment History</h2>
              <span class="detail-card__count">
                {{ transactionRecord.length }}
              </span>
            </div>

            <table class="detail-table">
              <thead>
                <tr>
                  <th>Paid Date</th>
                  <th class="detail-table__num">Amount Paid</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let record of transactionRecord">
                  <td>
                    {{ record.timestamp | date: 'dd/MM/yyyy' }}
                    <span class="detail-muted">
                      {{ record.timestamp | date: 'hh:mm a' }}
                    </span>
                  </td>
                  <td class="detail-table__num">
                    {{ record.amount_paid }} {{ transaction.source_currency }}
                  </td>
                </tr>
                <tr *ngIf="!transactionRecord.length">
                  <td colspan="2" class="detail-empty">
                    No payment records available
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </div>
  </ng-container>
</div>
